import type { RenderComponent } from 'hb-builder/types';

const Strips: Partial<RenderComponent> = () => <div />; // never used

Strips.componentName = 'Strips';

export default Strips;
